/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FlipVerticalIcon
 */
export default class FlipVerticalIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><g fillRule="nonzero"><path d="M16 8.92c0-.977-.52-1.87-1.345-2.307l-9.133-4.84c-1.202-.637-2.664-.12-3.265 1.154A2.707 2.707 0 002 4.08v4.84c0 1.425 1.09 2.58 2.434 2.58h9.132C14.91 11.5 16 10.345 16 8.92zm-2 .053c0 .259-.17.474-.395.519l-.087.008H4.482c-.237 0-.433-.186-.474-.432L4 8.973V4.027c0-.082.017-.162.05-.235a.468.468 0 01.566-.271l.081.035L13.734 8.5c.163.09.266.272.266.472zM16 15.08c0 .977-.52 1.87-1.345 2.307l-9.133 4.84c-1.202.637-2.664.12-3.265-1.154A2.707 2.707 0 012 19.92v-4.84c0-1.425 1.09-2.58 2.434-2.58h9.132C14.91 12.5 16 13.655 16 15.08zm-2-.053c0-.259-.17-.474-.395-.519l-.087-.008H4.482c-.237 0-.433.186-.474.432L4 15.027v4.946c0 .082.017.162.05.235.107.232.347.341.566.271l.081-.035 9.037-4.945a.534.534 0 00.266-.472z"/><path d="M21.725 19.429a1 1 0 01.05 1.322l-.086.092-1.98 1.882-.093.079a1 1 0 01-1.206-.012l-.092-.081-2.021-2-.084-.093a1.001 1.001 0 01-.007-1.226l.083-.095.094-.084a1 1 0 011.226-.007l.094.083.297.293V4.416l-.297.294a1 1 0 01-1.32.076l-.094-.084a1 1 0 01-.076-1.32l.084-.094 2.02-1.999a1 1 0 011.299-.093l.094.08 1.979 1.88a1 1 0 01-1.282 1.53l-.096-.08L20 4.308V19.69l.311-.297.096-.08a1 1 0 011.318.116z"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

